import React, { useEffect, useState, useCallback } from "react";
import styles from "./DataTable.module.css";
import Pagination from "./Pagination";
import { purchaseListing } from "../../../Bookclosure/Services/ApiHandler";

const DataTable = ({ PurchaseID = "691c3a16b2634815b26024fb" }) => {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

  const formatHeading = (text) => {
    return text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();
  };

  const loadData = useCallback(async () => {
    try {
      const response = await purchaseListing(PurchaseID, {
        page: currentPage,
        pageSize: rowsPerPage,
      });

      const res = response.data;

      setColumns(res.purchaseListingHeaders);
      setData(res.purchaseListing);
      setTotalPages(res.totalPages);

    } catch (error) {
      console.error("Error loading data:", error);
    }
  }, [PurchaseID, currentPage, rowsPerPage]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{formatHeading(col)}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                {columns.map((col) => (
                  <td key={col}>{row[col] ?? "-"}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          rowsPerPage={rowsPerPage}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default DataTable;
